var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Редактирование "+_vm._s(_vm.fetchedGroup.title))]),_c('div',[_c('FieldGroupForm',{attrs:{"group":_vm.fetchedGroup},on:{"onSubmit":_vm.onSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }